export default {
      id: "air-usage",
      viewBox: "0 0 27 25",
      url: __webpack_public_path__ + "img/icons.svg#air",
      toString: function () {
        return this.url;
      }
    }